import { render, staticRenderFns } from "./NotasNivel2DadosInconsistenciaDetalhado.vue?vue&type=template&id=2c2218b0"
import script from "./NotasNivel2DadosInconsistenciaDetalhado.vue?vue&type=script&lang=js"
export * from "./NotasNivel2DadosInconsistenciaDetalhado.vue?vue&type=script&lang=js"
import style0 from "./NotasNivel2DadosInconsistenciaDetalhado.vue?vue&type=style&index=0&id=2c2218b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports